import PropTypes from 'prop-types';
import React from 'react';
import { Box } from '@mui/material';
import { COLORS } from '../../EatClubTheme';

/**
 * TODO write summary here
 *
 * <h2>When to use</h2>
 *
 *
 * <h3>Where it's used</h3>
 *
 * <h2>Usage</h2>
 *
 * <h3>Features</h3>
 *
 * <h3>Props</h3>
 *
 *
 * <h3>Examples</h3>
 *
 * TODO
 *
 */
export const Divider = ({ color, mb, mt, style, direction }) => {
  const colorToUse = style?.color ?? color;
  return (
    <Box
      style={{
        borderBottom: direction === 'horizontal' ? `1px solid ${colorToUse}` : 'none',
        borderRight: direction === 'vertical' ? `1px solid ${colorToUse}` : 'none',
        width: direction === 'horizontal' ? `100%` : '1px',
        height: direction === 'vertical' ? `100%` : '1px',
        marginTop: mt,
        marginBottom: mb,
        ...style,
      }}
    />
  );
};

Divider.defaultProps = {
  color: COLORS.CLOUD,
  mb: 0,
  mt: 0,
  style: {},
  direction: 'horizontal',
};

Divider.propTypes = {
  color: PropTypes.string,
  mb: PropTypes.number,
  mt: PropTypes.number,
  style: PropTypes.shape({}),
  direction: PropTypes.string,
};
